import { useResourceContext } from "react-admin";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export function CreateRecordButton() {
  const navigate = useNavigate();
  const resource = useResourceContext();

  return (
    <Button
      className="CreateRecordButton"
      variant="outlined"
      startIcon={<AddIcon />}
      onClick={() => navigate(`/${resource}/create`)}
    >
      Hinzufügen
    </Button>
  );
}
